import { ApiInvalidParamError, ApiFatalError } from '@/errors/errors';

const getApiURL = (route) => `${process.env.VUE_APP_API_URL}/${route}`;

const getApiWPURL = (route) => `https://theatredeliege.be/${route}`;

const apiRequest = async (route, requestOptions) => {
  try {
    const url = getApiURL(route);
    const header = new Headers();
    if (route !== 'index.php' && route !== 'status.php') {
      header.append('Content-Type', 'application/json');
    }
    if (route === 'sapiti.php') {
      header.append('X-Sapiti-Proxy-Secret', process.env.VUE_APP_SAPITI_PROXY_SECRET);
    }

    const request = await fetch(url, {
      method: 'POST',
      headers: header,
      body: route === 'index.php' || route === 'status.php' ? requestOptions : JSON.stringify(requestOptions)
    });

    const response = await request.json();

    if (request.status === 200) {
      return response;
    }

    if (request.status === 400) {
      throw new ApiInvalidParamError('Error', response);
    } else {
      throw new ApiFatalError('Fatal error', response);
    }
  } finally {
    // Nothing
  }
};

const apiWPRequest = async (route) => {
  try {
    const url = getApiWPURL(route);

    const request = await fetch(url, { method: 'GET' });

    const response = await request.json();

    if (request.status === 200) {
      return response;
    }

    if (request.status === 400) {
      if (response.code === 'rest_post_invalid_page_number') {
        return response;
      }
      throw new ApiInvalidParamError('Error', response);
    } else {
      throw new ApiFatalError('Fatal error', response);
    }
  } finally {
    // Nothing
  }
};

export {
  getApiURL,
  getApiWPURL,
  apiRequest,
  apiWPRequest
};
